/* Proof page (/pages/proof): video loops and the part viewer. Loaded by several sections; runs once. */
(function () {
  if (window.__prfInit) return;
  window.__prfInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var noAuto = !!(reduce || saveData);

  function play(v) {
    if (!v || v.dataset.prfPaused === '1') return;
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function isShown(v) { return v.offsetParent !== null; }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && isShown(v) && !noAuto && !v.closest('[hidden]')) play(v);
      else if (!e.isIntersecting) v.pause();
    });
  }, { rootMargin: '200px 0px' }) : null;

  function watch(root) {
    (root || document).querySelectorAll('.prf video[data-prf-auto], .prf video[data-prf-lazy]').forEach(function (v) {
      if (v.dataset.prfWatched) return;
      v.dataset.prfWatched = '1';
      v.muted = true;
      if (io) io.observe(v); else if (!noAuto) play(v);
    });
  }

  // Hero play/pause toggle (WCAG 2.2.2)
  function initToggles() {
    document.querySelectorAll('.prf-hero__toggle').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var hero = btn.closest('.prf-hero');
      var paused = noAuto;
      function sync() {
        hero.querySelectorAll('video').forEach(function (v) {
          v.dataset.prfPaused = paused ? '1' : '0';
          if (paused) v.pause(); else if (isShown(v)) play(v);
        });
        btn.classList.toggle('is-paused', paused);
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      }
      btn.hidden = false;
      btn.addEventListener('click', function () { paused = !paused; sync(); });
      if (paused) sync();
    });
  }

  // Part viewer
  function initViewer(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var panels = Array.prototype.slice.call(root.querySelectorAll('.prf-part'));
    var n = panels.length;
    if (!n) return;
    var cur = 1;
    function select(i, focus) {
      cur = ((i - 1 + n) % n) + 1;
      panels.forEach(function (p) {
        var on = +p.dataset.n === cur;
        p.hidden = !on;
        var v = p.querySelector('video');
        if (v) { if (on && !noAuto) play(v); else v.pause(); }
      });
      root.querySelectorAll('[data-prf-pick]').forEach(function (b) {
        b.setAttribute('aria-pressed', +b.dataset.prfPick === cur ? 'true' : 'false');
      });
      if (focus) {
        var h = root.querySelector('.prf-part[data-n="' + cur + '"] h3');
        if (h) h.focus({ preventScroll: true });
      }
    }
    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-prf-pick]');
      if (pick) { select(+pick.dataset.prfPick); return; }
      if (e.target.closest('[data-prf-prev]')) select(cur - 1, true);
      else if (e.target.closest('[data-prf-next]')) select(cur + 1, true);
    });
    select(1);
  }

  // Desktop hero: size it so the benefits band below it is in view on the first screen
  function sizeHero() {
    document.querySelectorAll('.prf-hero').forEach(function (hero) {
      var media = hero.querySelector('.prf-hero__media');
      var band = document.querySelector('.prf-benefits');
      if (!media) return;
      if (window.innerWidth <= 768 || !band) { media.style.removeProperty('--prf-hero-h'); return; }
      var top = hero.getBoundingClientRect().top + window.pageYOffset;
      var h = window.innerHeight - top - band.offsetHeight;
      media.style.setProperty('--prf-hero-h', Math.max(h, 0) + 'px');
    });
  }

  function init() {
    watch();
    initToggles();
    document.querySelectorAll('[data-prf-viewer]').forEach(initViewer);
    sizeHero();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', sizeHero);
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sizeHero, 100); });
  // Theme editor: re-init sections when they reload
  document.addEventListener('shopify:section:load', function (e) {
    watch(e.target);
    initToggles();
    e.target.querySelectorAll('[data-prf-viewer]').forEach(initViewer);
    sizeHero();
  });
  window.matchMedia('(max-width: 768px)').addEventListener && window.matchMedia('(max-width: 768px)').addEventListener('change', function () {
    document.querySelectorAll('.prf video').forEach(function (v) { if (!isShown(v)) v.pause(); });
    if (io) document.querySelectorAll('.prf video[data-prf-watched]').forEach(function (v) { io.unobserve(v); io.observe(v); });
  });
})();
